export let ZSIQChatComponent = /*#__PURE__*/function (ZSIQChatComponent) {
  ZSIQChatComponent["OPERATOR_IMAGE"] = "OPERATOR_IMAGE";
  ZSIQChatComponent["RATING"] = "RATING";
  ZSIQChatComponent["FEEDBACK"] = "FEEDBACK";
  ZSIQChatComponent["SCREENSHOT"] = "SCREENSHOT";
  ZSIQChatComponent["PRE_CHAT_FORM"] = "PRE_CHAT_FORM";
  ZSIQChatComponent["VISITOR_NAME"] = "VISITOR_NAME";
  ZSIQChatComponent["EMAIL_TRANSCRIPT"] = "EMAIL_TRANSCRIPT";
  ZSIQChatComponent["FILE_SHARE"] = "FILE_SHARE";
  ZSIQChatComponent["MEDIA_CAPTURE"] = "MEDIA_CAPTURE";
  ZSIQChatComponent["END"] = "END";
  ZSIQChatComponent["END_WHEN_IN_QUEUE"] = "END_WHEN_IN_QUEUE";
  ZSIQChatComponent["END_WHEN_BOT_CONNECTED"] = "END_WHEN_BOT_CONNECTED";
  ZSIQChatComponent["END_WHEN_OPERATOR_CONNECTED"] = "END_WHEN_OPERATOR_CONNECTED";
  ZSIQChatComponent["REOPEN"] = "REOPEN";
  return ZSIQChatComponent;
}({});
//# sourceMappingURL=Chat.js.map